import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@utils/route.utils.ts';

const AiSettingsComponent = lazy(() => import('./ai-settings.tsx'));
const AiSettingsGeneralComponent = lazy(
  () => import('./pages/ai-settings-general/ai-settings-general.tsx')
);
const AiSettingsCapabilitiesComponent = lazy(
  () => import('./pages/ai-settings-capabilities/ai-settings-capabilities.tsx')
);
const AiSettingsFaqComponent = lazy(() => import('./pages/ai-settings-faq/ai-settings-faq.tsx'));

export const aiSettingsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <AiSettingsComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.AiSettings.General.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.AiSettings.General.path,
        element: (
          <Suspense>
            <AiSettingsGeneralComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.AiSettings.Capabilities.path,
        element: (
          <Suspense>
            <AiSettingsCapabilitiesComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.AiSettings.Faq.path,
        element: (
          <Suspense>
            <AiSettingsFaqComponent />
          </Suspense>
        )
      }
    ]
  }
];
